import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-operation-logs-filter', {
  mixins: [eventListenerMixin],

  connected() {
    this.form = this.querySelector('form');
    this.listenTo(this.querySelector('form'), 'tao:change', () => {
      this.sumbit();
    });
  },

  sumbit() {
    this.form.dispatchEvent(
      new Event('submit', {
        bubbles: true,
        cancelable: true,
      }),
    );
  },

  disconnected() {
    this.stopListening();
  },
});
